import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators} from '@angular/forms';
import { ClaimModel } from 'src/app/components/security/claims/models/claimModel';
import { environment } from 'src/environments/environment';
import { RestAPIService } from 'src/app/services/restapi.service';

@Component({
  selector: 'app-claims-addedit',
  templateUrl: './addeditclaim.component.html'
})
export class AddEditClaimsComponent {
    submitted: boolean = false;
    claim: ClaimModel = new ClaimModel();
    code = new FormControl('', [Validators.required]);
    description = new FormControl('', [Validators.required]);

    constructor(
        public _restAPI: RestAPIService,
        public dialogRef: MatDialogRef<AddEditClaimsComponent>,
        @Inject(MAT_DIALOG_DATA) public claimData: ClaimModel) {
            this.claim = JSON.parse(JSON.stringify(claimData));
            localStorage["applyClaimFilterValue"] = 'true';
        }

    async ngOnInit() {
        //init form controls
    }

    closeDialog(): void {
      this.dialogRef.close(false);
    }

    async saveClaim() {
      if(!this.code.invalid && (this.claim.code?.length ?? 0) > 0 && !this.description.invalid){
          if (this.claim.id != null && this.claim.id.length > 0) {
              let postData = {
                  id: this.claim.id,
                  code: this.claim.code,
                  description: this.claim.description,
              };

              this._restAPI.put<string>(environment.apiURL + 'api/claim/edit/' + this.claim.id, postData).subscribe({
                  next: (results) => {
                      this.dialogRef.close(true);
                  },
                  error: (error) => console.error(error)
              });
          }
          else {
              let postData = {
                  code: this.claim.code,
                  description: this.claim.description,
              };

              this._restAPI.post<string>(environment.apiURL + 'api/claim/add', postData).subscribe({
                  next: (results) => {
                      this.dialogRef.close(true);
                  },
                  error: (error) => console.error(error)
              });
          }
      }
    }
}